import apiClient from "./apiClient";

const resolveWsOrigin = () => {
  const base = apiClient?.defaults?.baseURL || "";
  if (!base || base.startsWith("/")) {
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${window.location.host}`;
  }

  try {
    const parsed = new URL(base);
    const protocol = parsed.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${parsed.host}`;
  } catch (_err) {
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${window.location.host}`;
  }
};

const requestWsTicket = async () => {
  const response = await apiClient.post("/auth/ws-ticket", {});
  return response?.data?.ticket;
};

const createSocketHandle = (path, onMessage) => {
  const handle = {
    socket: null,
    closed: false,
    close() {
      this.closed = true;
      if (this.socket) {
        this.socket.close();
      }
    },
  };

  requestWsTicket()
    .then((ticket) => {
      if (!ticket || handle.closed) return;
      const ws = new WebSocket(`${resolveWsOrigin()}${path}?ticket=${encodeURIComponent(ticket)}`);
      handle.socket = ws;
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          onMessage?.(data);
        } catch {
          onMessage?.({ message: event.data });
        }
      };
      ws.onerror = () => onMessage?.({ event: "ws_error" });
    })
    .catch(() => {
      onMessage?.({ event: "ws_ticket_error" });
    });

  return handle;
};

export const connectPackChannel = (packId, onMessage) =>
  createSocketHandle(`/ws/boardbacks/${packId}`, onMessage);

export const connectDocumentChannel = (docId, onMessage) =>
  createSocketHandle(`/ws/documents/${docId}`, onMessage);

